'use client'

import { createContext, useContext, useState } from 'react'

const BlogCategoryContext = createContext()

export const useBlogCategory = () => {
    const context = useContext(BlogCategoryContext)
    if (!context) {
        return { blogCategory: null, setBlogCategory: () => { } }
    }
    return context
}

export const BlogCategoryProvider = ({ children }) => {
    const [blogCategory, setBlogCategory] = useState(null)

    return (
        <BlogCategoryContext.Provider value={{ blogCategory, setBlogCategory }}>
            {children}
        </BlogCategoryContext.Provider>
    )
} 